export default __webpack_public_path__ + "images/a0bfd4ae57fea860d17a6d511e5b3045-football_small.webp";